const text = 'my snack!'
var showSnack = false;

export default {
    snackText: text,
    showSnack : showSnack,
}